import { Injectable } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private previousUrl: string;
  private currentUrl: string;

  public setPreviousUrl(url: string): void {
    this.previousUrl = url;
  }

  public getPreviousUrl(): string {
    return this.previousUrl;
  }
}
